import React, { useMemo } from 'react';
import { WidgetList } from '../../../../../Components/WidgetList/WidgetList';
import { AnalyticsPeriod } from '../../../../../Models';
import { AnalyticsServiceClass as ContactsAnalyticsServiceClass } from '../../../../../Services/Analytics/Contacts/AnalyticsService';
import { AnalyticsServiceClass as WorkspacesAnalyticsServiceClass } from '../../../../../Services/Analytics/Workspaces/AnalyticsService';

export interface MyWidgetsProps {
  analyticsService:
    | WorkspacesAnalyticsServiceClass
    | ContactsAnalyticsServiceClass;
  analyticsWidgetsContext: React.Context<string>;
  draggable: boolean;
  favourites: number[];
  period: AnalyticsPeriod;
  isResponseLimited: boolean;
  reportsLength: number;
  onRemove: (id: number) => void;
  onReorder: (ids: number[]) => void;
}

export const MyWidgets = ({
  analyticsService,
  analyticsWidgetsContext,
  favourites,
  draggable,
  period,
  isResponseLimited,
  reportsLength,
  onRemove,
  onReorder
}: MyWidgetsProps): React.ReactElement<MyWidgetsProps> => {
  const widgets = useMemo(
    () => analyticsService.getWidgets(favourites),
    [favourites, analyticsService]
  );

  return (
    <WidgetList
      analyticsWidgetsContext={analyticsWidgetsContext}
      widgets={widgets}
      draggable={draggable}
      isActive
      period={period}
      isResponseLimited={isResponseLimited}
      reportsLength={reportsLength}
      onRemove={onRemove}
      onReorder={onReorder}
    />
  );
};
